module.exports = __webpack_public_path__ + "static/img/obliqueLine.da82153e.png";